import { render, staticRenderFns } from "./variantsCounter.vue?vue&type=template&id=2bad8010&scoped=true&"
import script from "./variantsCounter.vue?vue&type=script&lang=js&"
export * from "./variantsCounter.vue?vue&type=script&lang=js&"
import style0 from "./variantsCounter.vue?vue&type=style&index=0&id=2bad8010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad8010",
  null
  
)

export default component.exports